<template>
    <v-card elevation="0" color="transparent">
        <v-row class="ma-3" :class="{'deep-purple lighten-5': notificationsSettingsFormFlag}">
            <v-col cols="6">
                <h3>
                    Notifications
                    <v-btn icon small color="primary"
                           @click="notificationsSettingsFormFlag = !notificationsSettingsFormFlag">
                        <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                </h3>
                <v-simple-table class="mb-5">
                    <tbody>
                    <tr>
                        <td>Report frequency</td>
                        <td>Weekly</td>
                    </tr>
                    <tr>
                        <td>Email addresses for the report</td>
                        <td>
              <span v-for="(user, key) in usersList" class="d-block" :key="key">
                  <v-icon small color="success" v-if="user.notification">mdi-email-check-outline</v-icon>
                  <v-icon small color="error" v-else>mdi-email-remove-outline</v-icon>
                  {{user.email}}
              </span>
                        </td>
                    </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
            <v-col>
                <template v-if="notificationsSettingsFormFlag">
                    <h3>Edit notifications</h3>
                    <notifications-user-form class="mt-6" :user-data="userData" :users="usersList"
                                             @close="closeListener"></notifications-user-form>
                </template>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
    import NotificationsUserForm from "../Forms/notificationsUserForm";

    export default {
        name: "editNotifications",
        components: {NotificationsUserForm},
        props: ['usersList', 'userData'],
        data: () => ({
          notificationsSettingsFormFlag: false
        }),
      methods: {
          closeListener(event){
              this.notificationsSettingsFormFlag = false;
              if (event && event.reload) {
                  this.$emit('reload');
              }
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Sections/editNotifications.vue